import * as log from '$lib/log.js';

export const load = async (_) => {
  // If we have data in the localStorage let's use it. Pending journal
  // events are synced later on page init. If we don't have data and have
  // token (this shouldn't be the case) let's fetch them before page is
  // loaded.
  const stored = log.load_state();
  if (stored !== null) {
    return stored;
  }

  return {
    subscriptions: [],
    log: [],
  };
};
